
define("tpl!drops/calendarWeekView/calendarWeekView.html", ["underscore"], function(_) { return function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="calendar-view week-view">\r\n    <div class="calendar-title">\r\n        <a class="previous-page clickable no-text-select">〈 </a>\r\n        <a class="next-page clickable no-text-select"> 〉</a>\r\n\r\n        <div class="date-as-title"></div>\r\n    </div>\r\n\r\n    <div class="weekday-headers-row">\r\n        <div class="weekday-headers"></div>\r\n    </div>\r\n\r\n    <div class="calendar-main">\r\n\r\n        <div class="hours">\r\n            \r\n        </div>\r\n\r\n        <div class="weekdays"></div>\r\n\r\n        <div class="clear"></div>\r\n\r\n    </div>\r\n</div>';
}
return __p;
};});

